import type { PanelGroup } from "@/features/workspace/navigation"

export function customerNavigationBindings(root: HTMLElement, navigation: readonly PanelGroup[]) {
  const groups = new Map(navigation.map(group => [group.id, group]))
  return Array.from(root.querySelectorAll<HTMLButtonElement>("button[data-customer-section]")).map(button => ({
    button,
    group: groups.get(button.dataset.customerSection ?? ""),
  }))
}

// DOM slots can survive a render after membership or company selection changes.
export function availableCustomerSlots<T extends {id:string}>(slots:readonly T[],navigation:readonly PanelGroup[]){
  const groups=new Map(navigation.map(group=>[group.id,group]))
  const seen=new Set<string>()
  return slots.flatMap(slot=>{const group=groups.get(slot.id);if(!group?.pages.length||seen.has(group.id))return [];seen.add(group.id);return [{slot,group}]})
}
